export const APP_URL = process.env.APP_URL
export const HOME_LINK = '/';
export const LOGIN_LINK = '/login';
export const CAMPAIGN_CREATE_LINK = '/campaign/start';
export const EDIT_CAMPAIGN_LINK = '/campaign/:campaignID/start';
export const CREATE_RECIPIENTS_IN_CAMPAIGN_LINK = '/campaign/:campaignID/add-recipients';
export const COMPOSE_MESSAGE_FOR_CAMPAIGN_LINK = '/campaign/:campaignID/compose';
export const MESSAGE_PREVIEW_FOR_CAMPAIGN_LINK = '/campaign/:campaignID/preview';
export const OPTIONS_FOR_CAMPAIGN_LINK = '/campaign/:campaignID/options';
export const FINAL_STEP_FOR_CAMPAIGN_LINK = '/campaign/:campaignID/send';
export const EDIT_SEQUENCE_LINK = '/campaign/:campaignID/edit-sequence';
export const CAMPAIGN_ALL_LINK = '/campaign/all';
export const CAMPAIGN_OVERVIEW_LINK = '/campaign/overview';
export const CAMPAIGN_SEQUENCE_LINK = '/campaign/sequence';
export const CAMPAIGN_RECIPIENTS_LINK = '/campaign/recipients';
export const CAMPAIGN_SETTINGS_LINK = '/campaign/settings';
export const CAMPAIGN_CALENDAR_LINK = '/campaign/calendar';
export const CAMPAIGN_OVERVIEW_URL = '/campaign/:campaignID/overview';
export const CAMPAIGN_SEQUENCE_URL = '/campaign/:campaignID/sequence';
export const CAMPAIGN_RECIPIENTS_URL = '/campaign/:campaignID/recipients';
export const CAMPAIGN_SETTINGS_URL = '/campaign/:campaignID/settings';
export const CAMPAIGN_LEADS_URL = '/campaign/leads';
export const CAMPAIGN_UPDATE_LINK = '/campaign/:campaignID/update';
export const CAMPAIGN_CALENDAR_URL = '/campaign/calendar/:emailAddress?';
export const MAIL_ACCOUNT_ALL_LINK = '/mail-accounts/all';
export const MAIL_ACCOUNT_CREATE_LINK = '/mail-accounts/create';
export const RECONNECT_GOOGLE_ACCOUNT_LINK = '/googlemail-accounts/reconnect';
export const CREATE_GOOGLE_SMTP_ACCOUNT_LINK = '/mail-accounts/:emailID/google-smtp/add';
export const EDIT_GOOGLE_SMTP_ACCOUNT_LINK = '/mail-accounts/:emailID/google-smtp/edit';
export const EDIT_SMTP_ACCOUNT_LINK = '/mail-accounts/smtp/edit/:email?';
export const EDIT_SMTP_SLUG = '/mail-accounts/smtp/edit/';
export const TEAMMATES_LINK = '/team/teammates';
export const UNSUBSCRIBERS_LINK = '/unsubscribers';
export const CONTACT_ALL_LINK = '/contact/all';
export const CONTACT_CREATE_LINK = '/contact/create';
export const LEADS_LINK = '/leads';
export const RESET_PASSWORD_LINK = '/reset-password/:token?';
export const RESET_PASSWORD_SLUG = '/reset-password/';
export const FORGOT_PASSWORD_LINK = '/forgot-password';
export const LOGOUT_LINK = '/logout';
export const TEST_UNSUBSCRIBE_LINK = '/unsubscribe/test';
export const GOOGLE_CLIENT_ID = process.env.GOOGLE_CLIENT_ID;
export const DAYS = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
export const CAMPAIGN_OPTIONS = [
    {
        id:'option_1',
        text:'Track opens',
        isChecked:true
    },
    {
        id:'option_2',
        text:'Track link clicks',
        isChecked:true
    },
    {
        id:'option_3',
        text:'schedule this send',
        isChecked:true
    },
    {
        id:'option_4',
        text:"I'll obey pertinent laws and I've read these important notes",
        isChecked:true
    }
];

export const COLOR_LIST = [
    "#8BC34A", "#D32F2F", "#2196F3", "#E91E63", "#FF9800", "#4CAF50", "#FF5733",
    "#FF6F61", "#3F51B5", "#9C27B0", "#FF5722", "#673AB7", "#00BCD4", "#03A9F4", 
    "#9E9E9E", "#C2185B", "#F44336", "#795548", "#00C853", "#9C27B0", "#8E24AA", 
    "#FFEB3B", "#FFC107", "#FF4081", "#FF6F00", "#1E88E5", "#388E3C", "#FFCA28", 
    "#F50057", "#0288D1", "#D50000", "#7C4DFF", "#4E342E", "#F57C00", "#CDDC39", 
    "#FF3D00", "#1976D2", "#212121", "#8D6E63", "#00BCD4", "#1E88E5", "#FF7043", 
    "#FF4081", "#4CAF50", "#F57C00", "#FF6F00", "#FF9800", "#00C853", "#9E9D24", 
    "#7B1FA2", "#F50057", "#C2185B", "#3E2723", "#0288D1", "#4CAF50", "#8BC34A", 
    "#FF3D00", "#D32F2F", "#CDDC39", "#FFEB3B", "#B71C1C", "#FF5252", "#8E24AA", 
    "#0288D1", "#795548", "#FF5733", "#9C27B0", "#F57C00", "#D50000", "#8D6E63", 
    "#8BC34A", "#9C27B0", "#F57C00", "#7C4DFF", "#FF4081", "#FFEB3B", "#7B1FA2", 
    "#00BCD4", "#9E9D24", "#D32F2F", "#FF9800", "#FF5252", "#FF4081", "#FF7043", 
    "#F50057", "#D32F2F", "#FFEB3B", "#FF6F61", "#8BC34A", "#00C853", "#F44336", 
    "#F50057", "#D50000", "#FFCA28", "#7C4DFF", "#FF9800", "#1E88E5", "#9C27B0"
  ];
export const RECIPIENT_HEADER = {created_at:"ADDED ON",latest_sent_at:"SENT ON"};

export const TOOLTIP = {
    max_emails_per_day_smtp:"Hint: This field is representing the Maximum emails that are send in a day. Please contact your service providers to get this number.",
    max_emails_per_day_gmail:"Hint: This field represets the maximum emails that would be sent in one day. For Gmail free account the limit is 500 and for paid account it is 2000.",
    minutes_between_sends:"Hint: This field is representing the minimum time duration (in minutes) between sending the emails.",
    maximum_emails_to_send_at_a_time:"Hint: This field is representing the maximum emails to send at a time (in minutes) in one brust."
}

export const VARIABLE_HELP_TEXT = "List of the variables that can be added from the contact list.";
export const MIME_HELP_TEXT = "Caution: Switching from HTML to plain text will remove the HTML formatting, and it cannot be restored.";